import { AxiosInstance } from 'axios';

import { COMPANY_URLS } from '@/constants/urls';
import Company from '@/model/General/Company';

class CompanyApi {
  axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getCompanyContact(company: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.axiosInstance
        .get(`${COMPANY_URLS.GET_CONTACT}?company=${company}`)
        .then(response => {
          resolve(response.data);
        })
        .catch((error: any) => {
          reject(error?.response?.data?.detail);
        });
    });
  }

  updateCompany(company: number, companyData: Partial<Company>): Promise<void> {
    return new Promise((resolve, reject) => {
      this.axiosInstance
        .patch(`${COMPANY_URLS.API_URL}/${company}`, companyData)
        .then(response => {
          resolve(response.data);
        })
        .catch((error: any) => {
          reject(error?.response?.data?.detail);
        });
    });
  }

  getPaymentMethod(company: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.axiosInstance
        .get(`${COMPANY_URLS.PAYMENT_METHOD}`, {
          params: {
            company,
          },
        })
        .then(response => {
          resolve(response.data);
        })
        .catch((error: any) => {
          reject(error?.response?.data?.detail);
        });
    });
  }

  createPaymentMethod(paymentMethodData: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this.axiosInstance
        .post(`${COMPANY_URLS.PAYMENT_METHOD}`, paymentMethodData)
        .then(response => {
          resolve(response.data);
        })
        .catch((error: any) => {
          reject(error?.response?.data?.detail);
        });
    });
  }

  updatePaymentMethod(paymentMethodId: number, paymentMethodData: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this.axiosInstance
        .patch(`${COMPANY_URLS.PAYMENT_METHOD}/${paymentMethodId}`, paymentMethodData, {
          params: {
            company: paymentMethodData.company,
          },
        })
        .then(response => {
          resolve(response.data);
        })
        .catch((error: any) => {
          reject(error?.response?.data?.detail);
        });
    });
  }
}

export default CompanyApi;
